<template>
    <div>
        <q-btn flat round icon="mdi-view-column-outline">
            <q-tooltip>Mostrar/Ocultar columnas</q-tooltip>
            <q-menu v-model="menuOpen">
                <div class="row no-wrap q-pa-md">
                    <div class="column q-gutter-xs">
                        <div class="text-h6 q-mb-sm">Columnas</div>
                        <q-toggle
                            v-for="col in options"
                            :key="col.value"
                            :label="col.label"
                            :model-value="modelValue.includes(col.value)"
                            @update:model-value="(val) => toggleColumna(col.value, val)"
                            dense
                        />
                    </div>
                </div>
                <div class="row no-wrap q-pa-md justify-around">
                    <q-btn flat color="primary" label="Todas" size="sm" @click="seleccionarTodas" />
                    <q-btn flat color="negative" label="Ninguna" size="sm" @click="ocultarTodas" />
                </div>
            </q-menu>
        </q-btn>
    </div>
</template>

<script setup>
import { ref } from "vue";

const props = defineProps({
    options: {
        type: Array,
        required: true,
    },
});

const modelValue = defineModel({ required: true });
const emit = defineEmits(["change"]);
const menuOpen = ref(false);

const toggleColumna = (nombre, visible) => {
    if (visible) {
        if (!modelValue.value.includes(nombre)) {
            modelValue.value = [...modelValue.value, nombre];
        }
    } else {
        modelValue.value = modelValue.value.filter((c) => c !== nombre);
    }
    emit("change");
};

const seleccionarTodas = () => {
    modelValue.value = props.options.map((col) => col.value);
    emit("change");
};

const ocultarTodas = () => {
    modelValue.value = [];
    emit("change");
};
</script>
